module.exports = __webpack_public_path__ + "media/country_flags/fr-0c64eda2.png";